import { ReactElement } from 'react';

import {
  AngleDown,
  AutoComplete,
  EquipUIFireflyV2Theme,
  Search,
} from '@equip.health/ui';

const {
  neutral: { primary: neutralPrimary },
  primary,
} = EquipUIFireflyV2Theme.colors;

interface ProviderSelectProps {
  handleProviderRemove?: (option: AutoCompleteOption) => void;
  handleProviderSearch: (searchTerm: string, isFirstPage: boolean) => void;
  handleProviderSelect: (option: AutoCompleteOption) => void;
  height: string;
  isDisabled: boolean;
  isLoading: boolean;
  multiple?: boolean;
  options: AutoCompleteOption[];
  placeholder?: string;
  selectedProvider?: AutoCompleteOption | AutoCompleteOption[];
  showSearchIcon?: boolean;
  toggleListOnFocus?: boolean;
  total: number;
}

const ProviderSelect = ({
  handleProviderRemove,
  handleProviderSearch,
  handleProviderSelect,
  height,
  isDisabled,
  isLoading,
  multiple = false,
  options,
  placeholder = 'Search by name or role',
  selectedProvider,
  showSearchIcon = false,
  toggleListOnFocus = false,
  total,
}: ProviderSelectProps): ReactElement => {
  return (
    <AutoComplete
      endIcon={<AngleDown fill={primary[100]} fillOpacity={1} />}
      fetchOptions={handleProviderSearch}
      id="availability-rule"
      isDebounced
      isDisabled={isDisabled}
      isDisabledSelectedButton={isDisabled}
      isInfiniteScrollable
      isLoading={isLoading}
      isRequired
      multiple={multiple}
      onRemove={handleProviderRemove}
      onSelect={handleProviderSelect}
      options={options}
      placeholder={placeholder}
      selected={
        selectedProvider && !Array.isArray(selectedProvider)
          ? [selectedProvider]
          : ((selectedProvider as AutoCompleteOption[]) ?? [])
      }
      selectedButtonHeight={height}
      selectedButtonSecondaryTextFontSize="10px"
      showSecondaryText
      showSelectedSecondaryText
      showSelectedSecondaryTextBold
      startIcon={
        showSearchIcon && (
          <Search fill={neutralPrimary} height="20px" width="20px" />
        )
      }
      toggleListOnFocus={toggleListOnFocus}
      totalOptionsCount={total}
    />
  );
};

export default ProviderSelect;
